<div class="topBottom-wrapper">
    <!-- Tabs section -->
    <section class="tabs-container">
        <div class="sg-tab hover-pointer" data-id="bottomunits-tab"
            [ngClass]="{'selectedTab': tabSelected === 'by-bottomunits'}" (click)="changeTab('by-bottomunits')">
            Bottom Units
        </div>
        <div class="sg-tab hover-pointer" data-id="topunits-tab"
            [ngClass]="{'selectedTab': tabSelected === 'by-topunits'}" (click)="changeTab('by-topunits')">
            Top Units
        </div>
        <div class="sg-tab hover-pointer" data-id="allunits-tab"
            [ngClass]="{'selectedTab': tabSelected === 'by-allunits'}" (click)="changeTab('by-allunits')">
            All Units
        </div>

        <div *ngIf="tabSelected === 'by-allunits'" class="ph-locations-paginator">
            <mat-paginator (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 20]"
                [length]="originalData.length">
            </mat-paginator>
        </div>
        <!-- Drop Down Options -->
        <div *ngIf="tabSelected !== 'by-allunits'" class="ph-locations-dropdown">
            <span class="tb-dropdown-container">
                Show:
                <mat-select id="tb-table-select" class="tb-table-select" [(value)]="preSelectedDropDownValue" panelClass="tb-table-select-panel"
                    (selectionChange)="onSelectChange($event)">
                    <mat-option *ngFor="let option of dropDownOptions"
                        [value]="option.value">{{option.option}}</mat-option>
                </mat-select>
            </span>
        </div>
    </section>
    <section id="top-bottom-table-header" class="top-bottom-insights-table" *ngIf="!isLoading; else loadingTemplate">
        <div class="header-box">
            <div class="location common-p">
                Location
            </div>
            <div class="performance-rating common-p w-15">
                Performance Rating
            </div>
            <div class="outof-product-issues common-p w-15">
                Out of Product Issues
            </div>
            <div class="issues common-p w-15">
                Issues
            </div>
            <div class="recurring-issues common-p w-15">
                Recurring Issues
            </div>
            <div class="action common-p w-15">
                Action
            </div>
        </div>

        <ng-container *ngIf="!isNoData; else noData">
            <ng-container *ngFor="let element of data; let i = index;">
                <div class="location-details-table" [id]="'topBottom-table-row-' + i">
                    <!-- Location block -->
                    <div class="location-block p-20">
                        <div class="location-accountname">
                            {{element?.accountName}}
                        </div>
                        <section class="location-address">
                            <div>{{element?.street}}</div>
                            <div>{{element.city ? element.city + ',' : ''}} {{element?.state}}</div>
                            <div>{{element?.zipCode}}</div>
                        </section>
                    </div>
                    <div class="performance-rating-block table-block">
                        <span class="performance-rating-blk"
                            [style.background-color]="getPerformanceRatingColor(element.performanceRating)">
                            {{element?.performanceRating}}
                        </span>
                    </div>
                    <div class="outof-product-issues-block table-block">
                        {{element?.outOfProductIssues}}
                    </div>
                    <div class="issues-block table-block">
                        {{element?.issues}}
                    </div>
                    <div class="recurring-issues-block table-block">
                        {{element?.recurringIssues}}
                    </div>
                    <div class="action-block table-block">
                        <button class="action-btn-block"
                         (click)="viewDetailsClicked(element)">
                          View Details
                        </button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- Display 'No Data' when there are no locations on load -->
        <ng-template #noData>
            <div class="no-data-container">
                <p>No data available</p>
            </div>
        </ng-template>
    </section>

    <!-- Loading Template -->
    <ng-template #loadingTemplate>
        <div class="loading-container">
            <loader size="medium"></loader>
            <p>Loading...</p>
        </div>
    </ng-template>
</div>
